import React from 'react';

import AlexLogo from 'Assets/alex-logo.svg';
import { Button, Paragraph } from 'DesignLibrary/atoms';
import Text from 'Shared/Text';
import { getMedicareCalloutUrl, trackMedicareProductSelect } from 'Utils/medicare';

import { MedicareContainer, NewTag, Wrapper } from './styled';
import { MedicareDestination } from '../../../constants';

export interface MedicareCalloutProps {
  client: string;
  isNextClicked: boolean;
  medicareDestination: MedicareDestination;
}

export const MedicareCallout = ({ client, isNextClicked, medicareDestination }: MedicareCalloutProps) => {
  const url = getMedicareCalloutUrl(medicareDestination, client);
  const handleClick = () => {
    trackMedicareProductSelect(medicareDestination, url);
  };
  return (
    <Wrapper>
      <MedicareContainer isNextClicked={isNextClicked}>
        <div className="text">
          <NewTag>
            <Text field="unified_landing_page.medicare_callout.tag" />
          </NewTag>
          <Paragraph size="small" color="--text-black">
            <Text
              field="unified_landing_page.medicare_callout.text"
              vars={{
                x: (
                  <span key="logo">
                    <img src={AlexLogo} alt="Alex" />
                  </span>
                ),
              }}
            />
          </Paragraph>
        </div>
        <div className="link">
          <Button stretch url={url} onClick={handleClick} buttonType="standalone" iconRight="ArrowUpRight">
            <Text field="unified_landing_page.medicare_callout.cta_button" />
          </Button>
        </div>
      </MedicareContainer>
    </Wrapper>
  );
};
